export const getSectionLinkPart = (pathname) => ['archive', 'policies', 'goals', 'techs', 'strats'].find((p) => pathname.includes(p));

export const getPathType = (sectionLinkPart) => {
  switch (sectionLinkPart) {
    case 'policy':
      return 'policies';
    case 'goal':
      return 'goals';
    case 'tech':
      return 'techs';
    default:
      return 'strats';
  }
};

export const getTypeProject = (sectionLinkPart) => {
  switch (sectionLinkPart) {
    case 'policies':
      return 'policy';
    case 'archive':
      return 'policy';
    case 'goals':
      return 'goal';
    case 'techs':
      return 'tech';
    default:
      return 'strategy';
  }
};

export const getProjectTypeText = (parentProjectType) => {
  switch (parentProjectType) {
    case 'strategy':
    case 'strats':
      return 'СП';
    case 'policy':
    case 'policies':
      return 'политики';
    case 'goal':
    case 'goals':
      return 'цели';
    case 'tech':
    case 'techs':
      return 'СТП';
    default:
      return '';
  }
};
